import type { IPinnedCtaData } from 'components/molecules/pinned-cta/entities/types';
import type { HeaderViewService } from 'components/organisms/header-v2/service/header-view.service';
import type { ILandingPage } from 'src/pages/layouts/entities/types';
import type { LayoutService } from 'src/pages/layouts/services/layout.service';

import { isEmptyObject } from '../is-object-empty/is-object-empty';

export function applyLayout(
    headerViewService: HeaderViewService,
    layoutService: LayoutService,
    viewData: ILandingPage,
    document: Document
): void {
    layoutService.configureFooterFromLayout(viewData?.layout);

    if (viewData?.layout?.page_background) {
        document.body.classList.add('page--background_' + viewData.layout.page_background);
    }

    if (viewData?.bannerOptions) {
        queueMicrotask(() => {
            headerViewService.setOptions(viewData.bannerOptions);
        });
    }

    if (viewData?.layout.pinned_button) {
        const pinnedCta = {
            ...viewData.layout.pinned_button,
            isHeaderExisted: viewData.layout.header_type !== 'none',
            isBannerExisted: !isEmptyObject(viewData.bannerOptions),
            exists: true,
        } as IPinnedCtaData;

        queueMicrotask(() => {
            headerViewService.setPinnedCtaOptions(pinnedCta);
        });
    }

    if (viewData?.layout?.is_article !== undefined) {
        layoutService.setIsArticle(viewData.layout.is_article);
    }
}
